module.exports = __webpack_public_path__ + "img/vlogo.f89d25e7.png";